window.addEventListener('DOMContentLoaded', (event) => {

  const amount_field = document.querySelector('body.Payment #Form_Form_PaymentAmount')

  if (amount_field) {

    function formatNumberWithCommas(n) {
      return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    function formatCurrency(event) {
      var value = event.target.value;
      if (value === "") {
        return;
      }
      var original_len = value.length;
      var caret_pos = event.target.selectionStart;
      if (value.indexOf(".") >= 0) {
        var decimal_pos = value.indexOf(".");
        var left_side = value.substring(0, decimal_pos);
        var right_side = value.substring(decimal_pos);
        if (left_side.length > 7) {
          left_side = left_side.substring(0, 7);
        }
        left_side = left_side.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        right_side = right_side.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (event.type == "blur") {
          right_side += "00";
        }
        right_side = right_side.substring(0, 2);
        value = "$" + left_side + "." + right_side;
      } else {
        if (value.length > 7) {
          value = value.substring(0, 7);
        }
        value = value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        value = "$" + value;
        if (event.type == "blur") {
          value += ".00";
        }
      }
      event.target.value = value;
      var updated_len = value.length;
      caret_pos = updated_len - original_len + caret_pos;
      event.target.setSelectionRange(caret_pos, caret_pos);
    }


    amount_field.addEventListener('keyup', formatCurrency)
    amount_field.addEventListener('blur', formatCurrency)
  }

})
